import Hero from "./components/Hero";
import WhatWeDo from "./components/WhatWeDo";
import WhyKarmaDelta from "./components/WhyKarmaDelta";
import InnovationParticipation from "./components/InnovationParticipation";
import ClosingCTA from "./components/ClosingCTA";
const HomePage = () => {
  return (
    <>
      <Hero />
      <WhatWeDo />
      <WhyKarmaDelta />
      <InnovationParticipation />
      <ClosingCTA />
    </>
  );
};

export default HomePage;